module.exports = __webpack_public_path__ + "static/media/Real-One-Specific.c729b44a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Real-One-Specific.woff2
// module id = 3643
// module chunks = 68